import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-53c4a041"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "mxa-title pb-2 pt-2",
  "data-test": "title"
}
const _hoisted_2 = { class: "mxa-content" }

import { onMounted } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { useStore } from '@/store'
import DownLoadSearch from '@/components/main/contents/download/DownLoadSearch.vue'
import DownLoadDetail from '@/components/main/contents/download/DownLoadDetail.vue'
import { initDom, useDownload } from '@/model/components/users/userDownload'
import { useDownloadDetail } from '@/model/components/users/userDownloadDetail'
import * as log from '@/model/util/log/Logger'


export default /*#__PURE__*/_defineComponent({
  __name: 'DownloadMail',
  props: {
  // URLダウンロードキー
  id: {
    type: String,
    default: '',
  },
  // 遷移時の引き継ぎキー
  searchkey: {
    type: String,
    default: '',
  },
  // 検索有無
  isSearch: {
    type: String,
    default: 'true',
  },
},
  setup(__props) {

const props = __props

log.trace(`Download setup start.`)

// プロパティ定義


// 状態
const store = useStore()
const router = useRouter()
const route = useRoute()
const { state, isChild } = useDownload(props, route)
const { isDetail } = useDownloadDetail(store)

// onMountedの登録
onMounted(async () => {
  log.trace('Download onMounted start.')
  // 認証情報の設定
  // 認証切れの場合はTOP画面に遷移する
  await initDom(state, store, router)
  log.trace('Download onMounted end.')
})

log.trace(`Download setup end.`)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.$t('body.main.download.title')), 1),
    _createElementVNode("div", _hoisted_2, [
      (_unref(isChild))
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createVNode(DownLoadSearch, {
              searchkey: _unref(state).key,
              isSearch: _unref(state).isSearch,
              failmsg: _unref(state).failSearchKey
            }, null, 8, ["searchkey", "isSearch", "failmsg"]),
            (_unref(isDetail))
              ? (_openBlock(), _createBlock(DownLoadDetail, {
                  key: 0,
                  failmsg: _unref(state).failDetailKey
                }, null, 8, ["failmsg"]))
              : _createCommentVNode("", true)
          ], 64))
        : _createCommentVNode("", true)
    ])
  ], 64))
}
}

})